module.exports = __webpack_public_path__ + "img/9788981337131.62d13138.jpg";